import { AsyncComponentLoader } from 'vue';

export const errorComponentRegistry = {
  'mpf-tenant-info': () =>
    import('../../lib/components/MpfTenantInfo/MpfTenantInfo.vue').then((m) => m.default),
} as const satisfies Record<string, AsyncComponentLoader>;

export type ErrorComponentName = keyof typeof errorComponentRegistry;
